import { Accordion, AccordionSummary } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import clsx from 'clsx'
import React, { ReactNode, useContext, useState } from 'react'

import TicketVariantContext, { TicketVariant } from '../../lib/TicketVariantContext'
import { ButtonText } from '../utils/typography'
import BenefitList from './BenefitList'

const useStyles = makeStyles(theme => ({
  expanded: {},
  promoted: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
  },
  root: {
    '&$expanded': {
      margin: 0,
      minHeight: 0,
    },
    '&:before': {
      display: 'none',
    },
    borderRadius: theme.shape.borderRadius,
  },
  soldOut: {
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.grey[500],
  },
  standard: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
  },
}))

const useSummaryStyles = makeStyles(theme => ({
  content: {
    '&$expanded': {
      margin: 0,
    },
    margin: 0,
  },
  expanded: {},
  root: {
    '&$expanded': {
      minHeight: 0,
    },
    minHeight: 0,
    padding: theme.spacing(1, 3),
  },
}))

type BenefitExpansionPanelProps = {
  children?: ReactNode
  className?: string
}

const BenefitExpansionPanel = ({ children, className }: BenefitExpansionPanelProps) => {
  const [expanded, setExpanded] = useState(false)
  const { variant } = useContext(TicketVariantContext)
  const classes = useStyles()
  const summaryClasses = useSummaryStyles()

  const onChange = () => setExpanded(!expanded)

  return (
    <Accordion
      className={clsx(
        classes.root,
        {
          [classes.promoted]: variant === TicketVariant.Promoted,
          [classes.soldOut]: variant === TicketVariant.SoldOut,
          [classes.standard]: variant === TicketVariant.Standard,
          [classes.expanded]: expanded,
        },
        className
      )}
      elevation={0}
      onChange={onChange}
    >
      <AccordionSummary
        IconButtonProps={{ color: 'inherit', size: 'small' }}
        classes={{ ...summaryClasses }}
        expandIcon={<ExpandMoreIcon fontSize="inherit" />}
      >
        <ButtonText color="inherit">{expanded ? 'Hide benefits' : 'Show benefits'}</ButtonText>
      </AccordionSummary>
      <BenefitList attached>{children}</BenefitList>
    </Accordion>
  )
}

export default BenefitExpansionPanel
